import { Alert } from "PFComponents/alert";
import useStorage from "PFCore/helpers/use_storage";
import { useTranslation } from "react-i18next";

export const FiltersV2AutoRefreshWarning = () => {
  const { t } = useTranslation("filters", { keyPrefix: "panel" });
  const [autoRefreshWarningDiscarded, setAutoRefreshWarningDiscarded] = useStorage<boolean>(
    `filters_auto_refresh_warning_discarded`,
    false
  );

  if (autoRefreshWarningDiscarded) {
    return null;
  }

  return (
    <Alert
      kind="general"
      title={t("autoRefreshWarning")}
      onClose={() => setAutoRefreshWarningDiscarded(true)}
    />
  );
};
